// eslint-disable-next-line banned-modules
'use strict';

import BaseModel from '@/classes/base.model';

const EmployeesFormModel = BaseModel.extend({

	defaults() {
		return {
			page: 0,
			pageSize: 10,
			count: 0,
			includeDisabled: false,
		};
	},

	toJSON() {
		const model = BaseModel.prototype.toJSON.call(this);
		delete model.count;
		return {
			parameters: model,
		};
	},

});

export default EmployeesFormModel;
